import React from 'react';
export function FooterSection() {
  return <footer className="bg-[#111111] text-gray-400 py-12 px-4 text-center" data-id="element-46">
      <div className="max-w-4xl mx-auto" data-id="element-47">
        <p className="mb-6 font-medium text-gray-300" data-id="element-48">
          © 2024 MEGA KIT ALFABETIZACIÓN EN AUTISMO. Todos los derechos
          reservados.
        </p>
        <div className="flex flex-wrap justify-center gap-4 text-sm" data-id="element-49">
          <a href="#" className="hover:text-white transition-colors" data-id="element-50">
            Términos y Condiciones
          </a>
          <span data-id="element-51">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-52">
            Política de Privacidad
          </a>
          <span data-id="element-53">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-54">
            Contacto
          </a>
        </div>
        <p className="mt-8 text-xs text-gray-600 max-w-2xl mx-auto" data-id="element-55">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}